import { memo } from 'react';
import { LuMapPinned, LuStore } from 'react-icons/lu';

import type { BlockModel } from '~api/services';
import { PropertyGroup, PropertyItem } from '~components';
import { Card, CardContent } from '~components/ui/card';

type BlockModelCardProps = {
  blockModel: BlockModel;
};

const BlockModelCard = memo(({ blockModel }: BlockModelCardProps) => {
  return (
    <Card>
      <CardContent className="space-y-4">
        <PropertyGroup withBorder>
          <PropertyItem
            label="Mine Site"
            icon={<LuMapPinned color="var(--color-primary)" size={20} />}
            value={blockModel.site}
            variant="featured"
          />
          <PropertyItem
            label="Deposit"
            icon={<LuStore color="var(--color-primary)" size={20} />}
            value={blockModel.deposit}
            variant="featured"
          />
        </PropertyGroup>
        <PropertyGroup>
          <PropertyItem label="Source" value={blockModel.source} contained />
          <PropertyItem label="Status" value={blockModel.status} contained />
          <PropertyItem label="Type" value={blockModel.type} contained />
        </PropertyGroup>
      </CardContent>
    </Card>
  );
});
BlockModelCard.displayName = 'BlockModelCard';

export { BlockModelCard };
